/* src/app/master-data/items/view-item/view-item.component.css */
:host {
  display: block;
  height: 100%;
}
pre {
  white-space: pre-wrap;
  word-break: break-word;
}
/*# sourceMappingURL=view-item.component-UXCTILAX.css.map */
